import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import i18n from '../../i18n';
import { API } from '../../services/api';
const api = new API();

import { checkAuth } from '../auth/authSlice';

export const fetchInitData = createAsyncThunk(
  'app/fetchInitData',
  async (data, thunkAPI) => {
    console.log('fetchInitData with data', data);
    try {
      let ownerId = data;

      if(!ownerId) {
        const currentState = thunkAPI.getState();
        ownerId = currentState.itemOwners.selected;
      }

      const response = await api.getGlobals(ownerId);

      if(response.status === 'ok') {
        return response.result;
      } else {
        return thunkAPI.rejectWithValue(response);
      }
    } catch(e) {
      console.error('app/fetchInitData', e);
      return thunkAPI.rejectWithValue('INTERNAL_SERVER_ERROR');
    }
  }
)

// First, create the thunk
export const initApp = createAsyncThunk(
  'app/init',
  async (data, thunkAPI) => {
    try {
      // First check auth
      const authResponse = await thunkAPI.dispatch(checkAuth());

      if(authResponse.type === 'auth/check/fulfilled') {
        // Valid session, fetch data
        await thunkAPI.dispatch(fetchInitData());
      }

      return true;
    } catch(e) {
      // System error or status code >= 500
      console.error('app/init', e);
      return thunkAPI.rejectWithValue('INTERNAL_SERVER_ERROR');
    }
  }
);

const initialState = {
  initialised: false,
  globals: {},
};

export const appSlice = createSlice({
  name: 'app',
  initialState,
  reducers: {
  },
  extraReducers: {
    [fetchInitData.fulfilled]: (state, action) => {
      state.globals = action.payload;
    },
    [initApp.fulfilled]: (state, action) => {
      state.initialised = true;
    },
    [initApp.rejected]: (state, action) => {
      state.initialised = true;
    }
  }
});

export const selectAppStatus = state => state.app.initialised;

export const selectItemSearchConfig = state => ({
  searchData: state.app.globals.searchData || [],
  typeOperations: state.app.globals.typeOperations || [],
  availableFields: state.app.globals.availableFields || []
});

export const selectItemFamilyFilters = state => {
  let vehicleTypes = state.app.globals.vehicleTypes;

  if(state.itemOwners?.selected === 'PC24') {
    // vehicleType has name & code, usagegroups has name & id. Normalize.
    vehicleTypes = (state.app.globals.usageGroups || []).map(item => ({name: item.name, code: item.id}));
  }

  return {
    vehicleTypes: vehicleTypes || [],
    seasons: state.app.globals.seasons || [],
    brands: state.app.globals.brands || []
  };
};

export const selectTyreAwardsFilters = state => state.app.globals.searchData?.itemFamilyCode || [];

export const selectFeeds = state => state.app.globals.feeds || [];

// Tyre globals (Item family + item)
export const selectGlobals = state => ({
  ...state.app.globals,
  feeds: state.app.globals.feeds.filter(feed => feed.content_type === 'tyres'),
});

// Wheel globals (Backend still has rims term, rims === wheels)
export const selectWheelGlobals = state => ({
  features: state.app.globals.rimFeatures,
  machines: state.app.globals.rimMachines,
  workTypes: state.app.globals.rimWorkTypes,
  feeds: state.app.globals.feeds.filter(feed => feed.content_type === 'rims'),
  brands: state.app.globals.brands, // This is shared with item families for now. Separate if different brands needed.
  productLines: state.app.globals.rimProductLines,
  tyreSizes: state.app.globals.tyreSizes,
});

// Tread globals
export const selectTreadGlobals = state => ({
  ...state.app.globals,
  feeds: state.app.globals.feeds.filter(feed => feed.content_type === 'treads'),
  tyrePositions: state.app.globals.tyrePositions,
});

// Catalog globals
export const selectCatalogGlobals = state => {
  /*
  catalogTypes = [{id: 'heavy', languages: ['en', 'de']}, {id: 'tbr', languages: ['en', 'de']}]
  */

  const types = state.app.globals.catalogTypes.map(type => {

    const typeLanguages = type.languages.map(id => ({id: id, name: i18n.t(`languages:${id}`)}));

    // Sort by label
    typeLanguages.sort((a, b) => a.name.localeCompare(b.name));

    // Put global first
    const globalIndex = typeLanguages.findIndex(c => c.id === 'en');
    const global = typeLanguages.splice(globalIndex, 1);
    typeLanguages.unshift(...global);

    return {
      id: type.id,
      name: i18n.t(`catalog:types:${type.id}`),
      languages: typeLanguages,
    };
  });

  return {
    types,
  }
};

export default appSlice.reducer;
